import moment from "moment";

const DUTCH_DATE_FORMAT = "DD-MM-YYYY";

export default {
  formatDutchDate: (input: moment.MomentInput) => {
    return moment(input).format(DUTCH_DATE_FORMAT);
  },
  dutchDateToDateWithWrittenMonth: (input: string) => {
    return moment(input, DUTCH_DATE_FORMAT).locale("nl").format("DD MMMM YYYY");
  },
  dutchDateToMoment: (input: moment.MomentInput) => {
    return moment(input, DUTCH_DATE_FORMAT);
  },
  strictDutchDateToMoment: (input: moment.MomentInput) => {
    return moment(input, DUTCH_DATE_FORMAT, true);
  },
  tomorrow: () => {
    return moment().add(1, "days");
  },
  dateIsTodayOrInTheFuture: (date: moment.MomentInput) => !moment(date, DUTCH_DATE_FORMAT).isBefore(moment(), "day"),
};
